module.exports = __webpack_public_path__ + "img/check-double.fb9894e8.svg";